import { useAuth } from "@/hooks/useAuth";
import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { LoadingPanel } from "./LoadingPanel";

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  // If a magic-link redirect just landed us here with the access token in the
  // URL hash, supabase-js needs a tick to parse it before the session shows up.
  // Render Loading instead of bouncing to /login, so the session can land.
  const hasAuthHash =
    typeof window !== "undefined" && window.location.hash.includes("access_token");

  if (loading || (hasAuthHash && !user)) return <LoadingPanel />;
  if (!user) {
    const from = `${location.pathname}${location.search}`;
    return <Navigate to={`/login?from=${encodeURIComponent(from)}`} replace />;
  }
  return <>{children}</>;
}
